import type { Facet } from '@faststore/sdk/dist/search/useSearchState'

interface Props {
  listType: 'plp' | 'vitrine' | 'Página de lista de produtos' | string
  listName: string
  productsCount: number
  selectedFacets?: Facet[]
  sort?: string
  page?: number
  base?: string
}

export function getCategoryLevel(base?: string) {
  if (!base) {
    return 1
  }

  // remove slash from start/end of base
  const clean = base.replace(/^\/+|\/+$/g, '')

  if (!clean) {
    return 1
  }

  return clean?.split('/')?.length ?? 1
}

/**
 *
 * @remarks
 * ⚠️ Tratamento especial para a faceta `sellerName`:
 * Por solicitação da **Stalse**, quando a faceta possui a chave `sellerName`,
 * o valor enviado para analytics é transformado para representar o filtro
 * de **desconto via PIX**.
 *
 * - `filter type`: enviado como `"desconto pix"` ao invés de `"sellerName"`
 * - `filter value`: quando o seller é `"iguasport-ltda"`, o valor enviado é `"true"`
 *
 * Esse mapeamento é necessário pois **não existe um filtro específico de desconto PIX**
 * no catálogo, sendo esse desconto identificado internamente pelo seller.
 *
 */
export function buildProductListObject({
  listName,
  listType,
  productsCount,
  sort,
  selectedFacets,
  page,
  base,
}: Props) {
  const filters = selectedFacets
    ? selectedFacets.map((facet) => ({
        'filter type':
          facet?.key === 'sellername' ? 'desconto pix' : facet?.key,
        'filter value':
          facet?.value === 'iguasport-ltda' ? 'true' : facet?.value,
      }))
    : []

  return {
    'product list type': listType,
    'product list name': listName,
    'product list level': getCategoryLevel(base),
    'filter details': filters?.length === 0 ? null : filters,
    'number filters applied': filters.length,
    'sort order': sort,
    'product list page number': page ?? 1,
    'number of products': productsCount,
  }
}
